import { createPortal } from 'react-dom';

export default function LoadingComponent() {
    const portalRoot = document.getElementById('portal-root');
    
    if (!portalRoot) {
        return null;
    }

    return createPortal(
        <div
            id="preloader"
            style={{
                position: 'fixed',
                zIndex: 2001,
                width: '100%',
                height: '100%',
            }}
        >
            <img
                style={{
                    opacity: 0.5,
                    position: 'fixed',
                    top: 'calc(50% - 50px)',
                    left: 'calc(50% - 50px)'
                }}
                src="/images/loading.gif"
                alt="loading"
            />
        </div>,
        portalRoot
    );
}